import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"
import { ShowCustomRepairTimeListItemsRequest, ShowCustomRepairTimeListItemsResponse } from "./models"

export async function showCustomRepairTimeListItems(body: ShowCustomRepairTimeListItemsRequest) {
    const url = `${WebserviceUrl.BasketCustomRepairTimes}/ShowCustomRepairTimeListItems`
    const response = await ajaxAuth<ShowCustomRepairTimeListItemsResponse>({ url, body })
    return {
        data: response?.customRepairTimes ?? [],
        pageIndex: body.pageIndex,
        endOfList: (response?.customRepairTimes?.length ?? 0) < body.pageSize,
    }
}
